import * as React from "react";
import cx from "classnames";

const styles = require("./gridLayout.scss");

interface IProps
  extends React.DetailedHTMLProps<any, any>,
    React.PropsWithChildren<{
      element?: keyof React.ReactHTML;
    }> {}

const GridLayout: React.FC<IProps> = ({
  element: elementTag = "div",
  children,
  className,
  ...props
}) => {
  return React.createElement(
    elementTag,
    { className: cx(styles.gridWrapper, className), ...props },
    children,
  );
};

const Grid560: React.FC<IProps> = ({
  element: elementTag = "div",
  children,
  className,
  ...props
}) => {
  return React.createElement(
    elementTag,
    { className: cx(styles.grid560, className), ...props },
    children,
  );
};

const Grid320: React.FC<IProps> = ({
  element: elementTag = "div",
  children,
  className,
  ...props
}) => {
  return React.createElement(
    elementTag,
    { className: cx(styles.grid320, className), ...props },
    children,
  );
};

export { GridLayout, Grid560, Grid320 };
